import { render, staticRenderFns } from "./pricingtelemundo.vue?vue&type=template&id=182b0332&scoped=true&"
import script from "./pricingtelemundo.vue?vue&type=script&lang=js&"
export * from "./pricingtelemundo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b0332",
  null
  
)

export default component.exports